


export const GITLAB_URL = 'https://git.unistra.fr';
export const API_URL = process.env.API_URL || '';

